import React from "react";
import Modal from 'react-bootstrap/Modal';
import { useState } from 'react';
import ViewMoreDetailsforAnnuityQuotes from "./ViewMoreDetailsforAnnuityQuotes";
import Button from 'react-bootstrap/Button';

import {
  Dropdown,
  DropdownButton,
  ButtonGroup,
} from "react-bootstrap";
import AuthUser from '../AuthUser'
import AlertMessage from "../Utils/AlertMessage";
export default (props) => {
  const { http, getUser } = AuthUser()
  let userdetails = getUser()
  const [show, setShow] = useState(false);
  const { data, refreshData } = props
  
  const [showModal, setShowModal] = useState(false);
  const [selectedid, setSelectedid] = useState(null);
  const[messagetype,setMessagetype]=useState()
  const[message,setMessage]=useState()
  const handleClose = () => { 
    setShow(false);
    setSelectedid()
  }
  //const handleShow = () => setShow(true);
  const handleView = (id) =>{
    setShow(true)
    setSelectedid(id)
  }
  const handleDownload = (id) => {
    let filename = `${data.transactionno}.pdf`;
    http.post(`/annuitydownload`, { id: id }, {
      responseType: 'blob',
    })
      .then((response) => {
        //console.log(response);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url; //''
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch(function (error) {
        // handle error
        console.log(error.response.data.error);
      });
  }
  const handleShowModal = (id) => {
    setSelectedid(id);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setSelectedid(null);
    setShowModal(false);
  };
  const handleDelete = () => {
    http.post(`/agent/deleteannuity/${userdetails.email}`, { id: selectedid })
      .then((response) => {
        //console.log(response); 
        setMessage('Annuity deleted successfully!')
        setMessagetype('success')
        refreshData();
        handleCloseModal();
      })
      .catch(function (error) {
        // handle error
        setMessage('Error in deleting!')
        setMessagetype('error')
        console.log(error.response.data.error);
      });
  }
  return (
    <div>
      <DropdownButton as={ButtonGroup}
        size="sm"
        autoClose="outside"
        variant="muted"
        style={{ maxHeight: "28px" }}
        title={
          <span>
            <i class="bi bi-three-dots"></i>
          </span>
        }>

        <Dropdown.Item href="#" onClick={() => handleView(data.id)}>View more details</Dropdown.Item>
        <Dropdown.Item href="#" onClick={() => handleDownload(data.id)}>Download PDF</Dropdown.Item>
        <Dropdown.Item href="#" onClick={() => handleShowModal(data.id)}>Delete</Dropdown.Item>
      </DropdownButton>

      <Modal show={show} onHide={handleClose} animation={false} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>More Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ViewMoreDetailsforAnnuityQuotes show={show} id={show === true ? selectedid : ''} close={() => { setShow(false); } } />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>

        </Modal.Footer>
      </Modal>
      <Modal size="md" aria-labelledby="contained-modal-title-vcenter" show={showModal} onHide={handleCloseModal} centered>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="input_fields_wrap">
            <div className="mb-2 col-md-12">
              <p style={{ color: '#2D8BB4' }}><strong>Are you sure you want to delete ?</strong></p>
              <AlertMessage
              message={message}
              type={messagetype}
              timeout={3000} // Clear after 5 seconds
              onClear={() => setMessage("")} />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="mb-2 col-md-12 text-center">
            <button type="button" className="btn btn-secondary ml-2" onClick={handleCloseModal}>No</button>
            <button type="submit" onClick={handleDelete} className="btn btn-primary ml-2">Yes</button>
          </div>
        </Modal.Footer>
      </Modal>
    </div>


  )
}
